import { forwardRef } from 'react';
import { IconButton, type IconButtonProps } from '@chakra-ui/react';
import { MIN_TOUCH_TARGET_PX } from '../layout/layoutConstants';

export type RiftboundIconButtonProps = IconButtonProps & {
  /** When true (default), enforce the 44px minimum touch target on the hit box. */
  minTouchTarget?: boolean;
};

/**
 * Icon button with shared press language and optional 44px min hit target.
 * Prefer this over raw Chakra IconButton on mobile-facing chrome.
 */
export const RiftboundIconButton = forwardRef<HTMLButtonElement, RiftboundIconButtonProps>(
  function RiftboundIconButton({ minTouchTarget = true, css, ...rest }, ref) {
    return (
      <IconButton
        ref={ref}
        WebkitTapHighlightColor="transparent"
        touchAction="manipulation"
        minW={minTouchTarget ? `${MIN_TOUCH_TARGET_PX}px` : undefined}
        minH={minTouchTarget ? `${MIN_TOUCH_TARGET_PX}px` : undefined}
        css={{
          WebkitTapHighlightColor: 'transparent',
          ...(typeof css === 'object' && css !== null ? css : {}),
        }}
        {...rest}
      />
    );
  },
);
